import { createSelector } from '@reduxjs/toolkit'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

export const selectIsSubcategoryColumnVisible = createSelector(
  [
    getFeatureToggle(FeatureToggle.INVENTORY_SUBCATEGORY_FILTERING),
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  ],
  (isSubcategoryFilteringEnabled, isInventoryKibFiltersEnabled) =>
    Boolean(isSubcategoryFilteringEnabled && isInventoryKibFiltersEnabled),
)
